<template>
  <div class="table-wrap xp-table-wrap">
    <a-table
      :columns="tableColumns"
      :data-source="dataSource"
      :loading="loading"
      :pagination="pagination"
      :row-key="rowKey"
      :scroll="tableScroll"
      :size="size"
      :bordered="bordered"
    >
      <template v-for="slot in tableSlots" :slot="slot" slot-scope="text, record, index">
        <slot :name="slot" :text="text" :record="record" :index="index" />
      </template>
    </a-table>
  </div>
</template>

<script>
import { normalizeTableColumns, calcTableScrollX } from '@/utils/table'

export default {
  name: 'XpTable',
  props: {
    columns: { type: Array, required: true },
    dataSource: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    pagination: { type: [Object, Boolean], default: false },
    rowKey: { type: [String, Function], default: 'id' },
    scroll: { type: Object, default: null },
    size: { type: String, default: 'middle' },
    bordered: { type: Boolean, default: false }
  },
  computed: {
    tableColumns() {
      return normalizeTableColumns(this.columns)
    },
    tableScroll() {
      if (this.scroll && this.scroll.x) {
        return this.scroll
      }
      return { x: calcTableScrollX(this.tableColumns) }
    },
    tableSlots() {
      return Object.keys(this.$scopedSlots)
    }
  }
}
</script>
